import { createSelector } from 'reselect';

const selectScribeTranscriptUI = state => state.scribeTranscriptUI;
export const selectCorrectionMode = createSelector(
  [selectScribeTranscriptUI],
  scribeTranscriptUI => scribeTranscriptUI.correctionMode
);

export const selectElectronCaptionMode = createSelector(
  [selectScribeTranscriptUI],
  scribeTranscriptUI => scribeTranscriptUI.electronCaptionMode
);
